/**
 * Merges multiple class names into a single string, filtering out falsy values
 * Adapted from clsx/classnames pattern
 */
export function cn(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ');
}
